export const frontmatter = {
    title: "OnnIA Documentation",
    description: "Guides, references, and resources to build and operate with the OnnIA platform.",
    sidebar_label: "Home",
    sidebar_order: 0,
    toc: false,
}

export const toc = []